export const EMPTY_VERSION_LABEL = "empty";
export const NOT_STARTED_VERSION_LABEL = "not started";
export const UNTITLED_VERSION_LABEL = "Untitled";
